"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OpenModalMobile = exports.OpenModalDesktop = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _tileTray = _interopRequireDefault(require("./tile.tray.proptypes"));
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var OpenModalMobile = function OpenModalMobile(trayHeight) {
  return (0, _styledComponents.keyframes)(["0%{opacity:0;height:0;}20%{opacity:0.2;height:", "px;}40%{opacity:0.4;height:", "px;}60%{opacity:0.6;height:", "px;}80%{opacity:0.8;height:", "px;}100%{opacity:1;}"], 0.2 * trayHeight, 0.4 * trayHeight, 0.6 * trayHeight, 0.8 * trayHeight);
};
exports.OpenModalMobile = OpenModalMobile;
var OpenModalDesktop = function OpenModalDesktop(trayHeight) {
  return (0, _styledComponents.keyframes)(["0%{opacity:0;}20%{opacity:0.2;}40%{opacity:0.4;}60%{opacity:0.6;}80%{opacity:0.8;}100%{opacity:1;}"]);
};
exports.OpenModalDesktop = OpenModalDesktop;
var MobileOuterWrapper = _styledComponents.default.div.withConfig({
  displayName: "TileTray__MobileOuterWrapper",
  componentId: "sc-anlmou-0"
})(["position:fixed;top:", ";bottom:", ";left:", ";right:", ";background-color:", ";opacity:", ";z-index:5;"], _constants.NO_SIZE, _constants.NO_SIZE, _constants.NO_SIZE, _constants.NO_SIZE, _constants.BACKGROUND, _constants.OPACITY);
var MobileInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "TileTray__MobileInnerWrapper",
  componentId: "sc-anlmou-1"
})(["position:fixed;bottom:", ";left:", ";height:85%;width:100%;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;overflow-y:auto;border-radius:", " ", " ", " ", ";background-color:", ";z-index:", ";animation:", " 0.3s ease-in-out 0s 1 normal forwards;overflow:auto;"], _constants.NO_SIZE, _constants.NO_SIZE, _constants.MOBILE_RADIUS, _constants.MOBILE_RADIUS, _constants.NO_SIZE, _constants.NO_SIZE, function (props) {
  return props.background ? props.theme.backgroundColor[props.background] : props.theme.backgroundColor.default;
}, _constants.ZINDEX, function (props) {
  return OpenModalMobile(props.trayHeight);
});
var DesktopOuterWrapper = _styledComponents.default.div.withConfig({
  displayName: "TileTray__DesktopOuterWrapper",
  componentId: "sc-anlmou-2"
})(["position:fixed;z-index:", ";width:100%;height:100%;opacity:", ";background-color:", ";right:", ";top:", ";"], function (props) {
  return props.zIndex ? props.zIndex - 1 : _constants.ZINDEX - 1;
}, _constants.OPACITY, _constants.BACKGROUND, _constants.NO_SIZE, _constants.NO_SIZE);
var DesktopInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "TileTray__DesktopInnerWrapper",
  componentId: "sc-anlmou-3"
})(["position:absolute;display:flex;align-items:center;opacity:1;height:auto !important;background-color:", ";z-index:", ";width:inherit;max-width:inherit;border-radius:", " ", " ", " ", ";box-shadow:", " ", " ", " rgba(0,0,0,0.08) inset;padding-top:", ";padding-bottom:", ";animation:", " 0.3s ease-in-out 0s 1 normal forwards;"], function (props) {
  return props.background ? props.theme.backgroundColor[props.background] : props.theme.backgroundColor.default;
}, function (props) {
  return props.zIndex ? props.zIndex : _constants.ZINDEX;
}, _constants.NO_SIZE, _constants.NO_SIZE, function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.space.micro;
}, _constants.NO_SIZE, function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.space.tiny;
}, function (props) {
  return props.theme.space.tiny;
}, function (props) {
  return props.theme.space.tiny;
}, function (props) {
  return OpenModalDesktop(props.trayHeight);
}); // const RectangleWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   margin-top: 13px;
// `;
// const MobileRectangle = styled.div`
//   width: 40px;
//   height: 5px;
//   background: ${(props) => props.theme.colors.greyLight};
//   opacity: 0.5;
//   border-radius: 50px;
// `;

var OpenTray = function OpenTray(props, wrapperRef, height) {
  var type = props.type,
    theme = props.theme,
    background = props.background,
    children = props.children,
    customProperties = props.customProperties,
    zIndex = props.zIndex,
    onTrayBlur = props.onTrayBlur;
  var customPropertiesTray = props.customPropertiesTray;
  customPropertiesTray = _objectSpread(_objectSpread({}, customPropertiesTray), {}, {
    className: 'showTray'
  });
  if (type === _constants.DEVICE_TYPE.MOBILE) {
    var mobileHeight = 0;
    if (typeof window !== 'undefined') {
      mobileHeight = window.innerHeight * 0.85;
    }
    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_Theme.default, {
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(MobileInnerWrapper, (0, _extends2.default)({
      background: background,
      trayHeight: mobileHeight
    }, customPropertiesTray), children), /*#__PURE__*/_react.default.createElement(MobileOuterWrapper, customProperties)), document.getElementsByTagName('body')[0]);
  }
  var TrayHeight = wrapperRef && wrapperRef.current && wrapperRef.current.offsetHeight ? parseInt(wrapperRef.current.offsetHeight, 10) : parseInt(_constants.MIN_HEIGHT, 10);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(DesktopInnerWrapper, (0, _extends2.default)({
    onBlur: function onBlur(e) {
      return _utilities.default.outsideOfParent(e, wrapperRef, onTrayBlur);
    },
    trayHeight: TrayHeight,
    ref: wrapperRef,
    zIndex: zIndex,
    background: background
  }, customPropertiesTray), children), /*#__PURE__*/_react.default.createElement(DesktopOuterWrapper, (0, _extends2.default)({
    zIndex: zIndex
  }, customProperties, {
    top: height
  })));
};
OpenTray.propTypes = _tileTray.default.PropTypes;
var TileTray = function TileTray(props) {
  var open = props.open;
  var wrapperRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  (0, _react.useEffect)(function () {
    if (wrapperRef.current) {
      var height = parseInt(wrapperRef.current.offsetHeight, 10) + parseInt(wrapperRef.current.offsetTop, 10);
      setValue(height);
    }
  }, []);
  if (open) {
    return OpenTray(props, wrapperRef, value);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
TileTray.propTypes = _tileTray.default.PropTypes;
TileTray.defaultProps = _tileTray.default.DefaultProps;
var _default = TileTray;
exports.default = _default;